import {memo} from 'react';
import type React from 'react';
import PlusIcon from '@/icons/plus.svg';

type HoverPosition = 'left' | 'right' | 'bottom';

type Props = {
  position: HoverPosition;
  onCreateScreen: (position: HoverPosition) => void;
};

// CSS calc expressions for zoom-independent sizing
const ZONE_WIDTH = 'calc(12px * var(--inverse-zoom, 1))';
const BUTTON_GAP = 'calc(8px * var(--inverse-zoom, 1))';

const getZoneStyle = (position: HoverPosition): React.CSSProperties => {
  switch (position) {
    case 'left':
      return {
        left: `calc(-1 * ${ZONE_WIDTH})`,
        top: 0,
        width: ZONE_WIDTH,
        height: '100%',
      };
    case 'right':
      return {
        right: `calc(-1 * ${ZONE_WIDTH})`,
        top: 0,
        width: ZONE_WIDTH,
        height: '100%',
      };
    case 'bottom':
      return {
        bottom: `calc(-1 * ${ZONE_WIDTH})`,
        left: 0,
        width: '100%',
        height: ZONE_WIDTH,
      };
  }
};

const getButtonContainerStyle = (
  position: HoverPosition,
): React.CSSProperties => {
  const base: React.CSSProperties = {
    position: 'absolute',
    transform: 'scale(var(--inverse-zoom, 1))',
  };

  switch (position) {
    case 'left':
      return {
        ...base,
        right: BUTTON_GAP,
        top: '50%',
        transform: 'translateY(-50%) scale(var(--inverse-zoom, 1))',
        transformOrigin: 'center right',
      };
    case 'right':
      return {
        ...base,
        left: BUTTON_GAP,
        top: '50%',
        transform: 'translateY(-50%) scale(var(--inverse-zoom, 1))',
        transformOrigin: 'center left',
      };
    case 'bottom':
      return {
        ...base,
        top: BUTTON_GAP,
        left: '50%',
        transform: 'translateX(-50%) scale(var(--inverse-zoom, 1))',
        transformOrigin: 'top center',
      };
  }
};

export const FrameBorderHoverZone = memo(
  ({position, onCreateScreen}: Props) => {
    return (
      <div
        data-zoom-chrome='border-zone'
        className='group absolute z-10 flex cursor-pointer items-center justify-center'
        style={getZoneStyle(position)}
        onClick={(e) => {
          e.stopPropagation();
          onCreateScreen(position);
        }}
      >
        <div style={getButtonContainerStyle(position)}>
          <div className='shadow-ui-sm flex h-8 w-8 flex-shrink-0 scale-90 items-center justify-center rounded-full bg-tooltip text-white opacity-0 transition-[transform,opacity] duration-75 group-hover:scale-100 group-hover:opacity-100'>
            <PlusIcon className='h-6 w-6' />
          </div>
        </div>
      </div>
    );
  },
);
FrameBorderHoverZone.displayName = 'FrameBorderHoverZone';
